import Integration from "./integration.container";

export default Integration;